import {forwardRef} from "react";

import {
  LimitCheckWithInstantCheckout,
  LimitCheckWithInstantCheckoutComponent,
} from "@/pages/billing/v2/InstantCheckout/LimitCheckWithInstantCheckout.tsx";

interface FreeTrialInstantCheckoutProps {
  freeTrialRemaining: number;
}

export const FreeTrialInstantCheckout = forwardRef<
  LimitCheckWithInstantCheckoutComponent,
  FreeTrialInstantCheckoutProps
>(({freeTrialRemaining}, ref) => {
  return (
    <LimitCheckWithInstantCheckout
      getRequestMessage={() =>
        "If you would like to request a subscription, please send a request to the owner of this account below to upgrade."
      }
      getTitleMessage={() =>
        freeTrialRemaining > 0
          ? "Subscribe to keep monitoring without interruption."
          : "Subscribe to resume monitoring activities."
      }
      ref={ref}
      showTierLimits={false}
      showCustomizeSubscription
    />
  );
});
